__turbopack_context__.v({
  "first-place-wrapper": "styles-module__DtWeQW__first-place-wrapper",
  "podium-wrapper": "styles-module__DtWeQW__podium-wrapper",
  "position-wrapper": "styles-module__DtWeQW__position-wrapper",
  "user-icon-wrapper": "styles-module__DtWeQW__user-icon-wrapper",
});
